import React from "react";

interface SortDropdownProps {
  sortOption: string;
  onSortChange: (option: string) => void;
}

export default function SortDropdown({
  sortOption,
  onSortChange,
}: SortDropdownProps) {
  const handleSortChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newSortOption = e.target.value;
    onSortChange(newSortOption);
  };

  return (
    <select
      className="border border-gray-300 text-[#1C1D1D] text-[16px]  font-['Ainslie_Sans']  font-medium py-2 px-3 bg-white focus:outline-none w-1/2 md:w-64"
      value={sortOption}
      onChange={handleSortChange}
    >
      <option
        className="font-['Ainslie_Sans'] text-[#1C1D1D] text-[16px]"
        value="featured"
      >
        Featured
      </option>
      <option
        className="font-['Ainslie_Sans'] text-[#1C1D1D] text-[16px]"
        value="best_selling"
      >
        Best selling
      </option>
      <option
        className="font-['Ainslie_Sans'] text-[#1C1D1D] text-[16px]"
        value="title_asc"
      >
        Alphabetically, A–Z
      </option>
      <option
        className="font-['Ainslie_Sans'] text-[#1C1D1D] text-[16px]"
        value="title_desc"
      >
        Alphabetically, Z–A
      </option>
      <option
        className="font-['Ainslie_Sans'] text-[#1C1D1D] text-[16px]"
        value="price_asc"
      >
        Price, low to high
      </option>
      <option
        className="font-['Ainslie_Sans'] text-[#1C1D1D] text-[16px]"
        value="price_desc"
      >
        Price, high to low
      </option>
      <option
        className="font-['Ainslie_Sans'] text-[#1C1D1D] text-[16px]"
        value="date_desc"
      >
        Date, old to new
      </option>
      <option
        className="font-['Ainslie_Sans'] text-[#1C1D1D] text-[16px]"
        value="date_asc"
      >
        Date, new to old
      </option>
    </select>
  );
}
